export default __webpack_public_path__ + "static/media/screenshot8.cff4e079.jpg";